import { useEffect, useState } from "react";
import styles from "./styles.module.css";

interface Props {
  title: string;
  sourcesCount: number;
}

export const InfoSourcesCount = ({ title, sourcesCount }: Props) => {
  const [prevCount, setPrevCount] = useState<number>(sourcesCount ?? 0);

  useEffect(() => {
    if (sourcesCount !== prevCount) {
      setPrevCount(sourcesCount);
    }
  }, [sourcesCount, prevCount]);

  return (
    <div className={styles["sources-info"]}>
      <div>{title}</div>
      <div className={styles.counter}>
        <span key={sourcesCount} className={styles.number}>
          {sourcesCount}
        </span>
      </div>
    </div>
  );
};
